import { QtmButton, QtmIcon } from '@qtm/react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import DeleteUserSelectionBtn from 'modules/Users/DeleteUserSelectionBtn';
import UserDataTableFilter from 'modules/Users/UserDataTableFilter';
import { useNavigate } from 'react-router-dom';
import { setSelection } from 'shared/reducers/usersTableSlice';

const UserTableActions = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const selection = useAppSelector(state => state.usersTable.selection);

  const onCreate = () => {
    navigate('/users/new');
    dispatch(setSelection([]));
  };

  const onEdit = (id: number) => () => {
    navigate('/users/' + id);
    dispatch(setSelection([]));
  };

  return (
    <div className="table-actions">
      <UserDataTableFilter />
      <div className="context-actions">
        {selection.length > 0 ? (
          <>
            {selection.length === 1 && (
              <QtmButton variant="outline" onClick={onEdit(selection[0])}>
                <QtmIcon icon="edit" />
                <span>Edit</span>
              </QtmButton>
            )}

            <DeleteUserSelectionBtn ids={selection} />
          </>
        ) : (
          <QtmButton variant="outline" onClick={onCreate}>
            <QtmIcon icon="add" />
            <span>Add</span>
          </QtmButton>
        )}
      </div>
    </div>
  );
};

export default UserTableActions;
